import React from 'react';

export default function Footer() {
  const scrollToWhatWeDo = () => {
    const element = document.getElementById('what-we-do');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const companyLinks = [
    { label: 'Home', href: '/' },
    { label: 'About Us', href: '/about' },
    { label: 'Case Studies', href: '#', comingSoon: true },
    { label: 'Blog', href: '#', comingSoon: true },
    { label: 'Contact Support', href: '/contact' }
  ];

  const expertiseLinks = [
    { label: 'Cloud Architecture', action: 'scroll' },
    { label: 'Cyber Security', action: 'scroll' },
    { label: 'Enterprise ERPs', action: 'scroll' },
    { label: 'Mobile Applications', action: 'scroll' },
    { label: 'DevOps Solutions', action: 'scroll' }
  ];

  const socialLinks = [
    { icon: 'twitter', viewBox: '0 0 24 24', path: 'M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z' },
    { icon: 'linkedin', viewBox: '0 0 24 24', path: 'M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z' },
    { icon: 'instagram', viewBox: '0 0 24 24', path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 2.691 4.919 5.833.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.142-1.667 5.685-4.919 5.833-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-2.699-4.919-5.833-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.127 1.666-5.684 4.919-5.833 1.265-.058 1.645-.07 4.849-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z' },
    { icon: 'facebook', viewBox: '0 0 24 24', path: 'M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z' },
    { icon: 'youtube', viewBox: '0 0 24 24', path: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' }
  ];

  const contactInfo = [
    { 
      icon: 'location',
      text: 'Panchwati Colony Phase 3, Karond, Bhopal, MP 462038',
      href: '#'
    },
    { 
      icon: 'email',
      text: 'garudstacks@gmail.com',
      href: 'mailto:garudstacks@gmail.com'
    },
    { 
      icon: 'phone',
      text: '+91 95229 50225',
      href: 'tel:+919522950225'
    },
    { 
      icon: 'phone',
      text: '+91 98065 20216',
      href: 'tel:+919806520216'
    }
  ];

  const footerLinks = [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' }
  ];

  const LocationIcon = () => (
    <svg className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
    </svg>
  );

  const EmailIcon = () => (
    <svg className="w-5 h-5 text-amber-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
    </svg>
  );

  const PhoneIcon = () => (
    <svg className="w-5 h-5 text-amber-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
    </svg>
  );

  const getContactIcon = (type) => {
    switch (type) {
      case 'location':
        return <LocationIcon />;
      case 'email':
        return <EmailIcon />;
      case 'phone':
        return <PhoneIcon />;
      default:
        return null;
    }
  };

  return (
    <footer className="bg-gray-950 pt-20 pb-10 border-t border-gray-900">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8 mb-16">
          
          {/* Brand & About (Takes 2 columns on lg) */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img src="./img/logo.png" alt="GarudStacks Logo" className="w-20 h-20" />
              <div>
                <h2 className="font-bold text-xl uppercase tracking-wide text-white">Garud Stacks</h2>
                <p className="text-[10px] font-bold text-amber-500 uppercase tracking-widest">Private Limited</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-8 max-w-sm">
              Garud Stacks engineers scalable cloud infrastructure, AI-driven solutions, and enterprise software to accelerate your digital transformation. Trusted by enterprises worldwide for precision, innovation, and legendary speed.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social, index) => {
                const socialUrls = {
                  twitter: 'https://twitter.com/GarudStacks',
                  linkedin: 'https://linkedin.com/company/garud-stacks',
                  instagram: 'https://instagram.com/garudstacks',
                  facebook: 'https://facebook.com/GarudStacks',
                  youtube: 'https://youtube.com/@GarudStacks'
                };
                return (
                  <a
                    key={index}
                    href={socialUrls[social.icon] || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-gray-900 border border-gray-800 flex items-center justify-center text-gray-400 hover:text-amber-500 hover:border-amber-500 hover:bg-amber-500/10 transition-all duration-300"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox={social.viewBox}>
                      <path d={social.path}></path>
                    </svg>
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links - Company */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-6">Company</h4>
            <ul className="space-y-4">
              {companyLinks.map((link, index) => (
                <li key={index}>
                  {link.comingSoon ? (
                    <span className="text-gray-500 text-sm flex items-center gap-2">
                      {link.label}
                      <span className="text-[10px] bg-amber-500/20 text-amber-500 px-2 py-0.5 rounded font-bold">Soon</span>
                    </span>
                  ) : (
                    <a href={link.href} className="text-gray-400 hover:text-amber-500 text-sm transition-colors">
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Services - Expertise */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-6">Expertise</h4>
            <ul className="space-y-4">
              {expertiseLinks.map((link, index) => (
                <li key={index}>
                  <button onClick={scrollToWhatWeDo} className="text-gray-400 hover:text-amber-500 text-sm transition-colors cursor-pointer bg-none border-none p-0 text-left">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-6">Get in Touch</h4>
            <ul className="space-y-4">
              {contactInfo.map((info, index) => (
                <li
                  key={index}
                  className={`flex items-start gap-3 text-gray-400 text-sm ${
                    info.icon !== 'location' ? 'items-center' : ''
                  }`}
                >
                  {getContactIcon(info.icon)}
                  {info.icon === 'location' ? (
                    <span>{info.text}</span>
                  ) : (
                    <a href={info.href} className="hover:text-amber-500 transition-colors">
                      {info.text}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          
        </div>
        
        {/* Bottom Copyright */}
        <div className="pt-8 border-t border-gray-900 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs font-medium tracking-wide">
            &copy; 2026 Garud Stacks Pvt. Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs font-medium text-gray-500 flex-wrap justify-center md:justify-end">
            {footerLinks.map((link, index) => (
              <a key={index} href={link.href} className="hover:text-amber-500 transition-colors">
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
